import { css } from "@emotion/react";
import Skeleton from "@mui/material/Skeleton";

import { colors } from "@dotnet/telematics-design-system";

import { useMediaQueries } from "shared/hooks/useMediaQueries";

const FilteredValuesLoader = () => {
    const { gray100, gray200 } = colors;

    const { fromSm } = useMediaQueries();

    return (
        <div
            css={css({
                display: "flex",
                alignItems: "center",
                borderTop: `1px solid ${gray200}`,
                padding: "9px 24px 10px 24px",

                span: {
                    borderRadius: "6px",
                    background: gray100
                }
            })}
        >
            <Skeleton variant="rectangular" width={77} height={20} />

            <div
                css={css({
                    display: "flex",
                    alignItems: "center",
                    flexWrap: "wrap",
                    columnGap: "6px",
                    rowGap: "6px",
                    marginLeft: "16px"
                })}
            >
                <Skeleton variant="rectangular" width={140} height={32} />

                {fromSm && (
                    <Skeleton variant="rectangular" width={140} height={32} />
                )}

                {fromSm && (
                    <Skeleton variant="rectangular" width={80} height={20} />
                )}
            </div>
        </div>
    );
};

export default FilteredValuesLoader;
